<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    submitTitle="Unlink"
    icon="fa-unlink"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This will unlink the {{itemType}} from {{ integrationName }} and cannot be undone</NotificationBarTitle>

        <ul>
          <li>The {{itemType}}'s link to {{ integrationName }} will be removed</li>
          <li>On the next sync, the {{itemType}} will be re-created in {{ integrationName }} as a new {{itemType}} and linked back to this object</li>
          <li>Any existing linked {{itemType}}s in {{ integrationName }} will not be affected and can be manually deleted if required</li>
          <li>If the {{itemType}} is already in {{ integrationName }}, the {{itemType}} will be duplicated in {{ integrationName }} after unlinking &amp; re-syncing</li>
          <li>All associated (eg, allocations) data linked to the {{itemType}} in {{ integrationName }} will also be unlinked and automatically resync on the next sync cycle</li>
          <li>Only do this action if you are sure you want to unlink and re-sync the {{itemType}} and have cleaned up all related data in {{ integrationName }}</li>
          <li>If you are unlinking due to sync errors, please contact support to investigate the root cause of the sync issue</li>
        </ul>
      </NotificationBar>      
      <NotificationBar type="warning">
        <ul>
          <li>Only do this action if you are sure you want to unlink and re-sync the {{itemType}} and have cleaned up all related data in {{ integrationName }}</li>
        </ul>
      </NotificationBar>

      <FormRow :label="`${integrationName} UUID`" v-if="internalId">
        <FormStaticLabel>{{ internalId }}</FormStaticLabel>
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'IntegrationUnlinkDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    integrationLinkData: Object
  },
  data() {
    return {
      item: {},
      dialogForm: {},
      submitting: false,
    }
  },
  mounted() {
  },
  computed: {
    title() {
      if(this.integrationLinkData && this.integrationLinkData.options && this.integrationLinkData.options.unlink) {
        return this.integrationLinkData.options.unlink.name
      }
      return 'Unlink Integration'
    },
    integrationName() {
      if(this.integrationLinkData)
        return this.integrationLinkData.name
      return ''
    },
    itemType() {
      if(this.integrationLinkData) {
        return this.integrationLinkData.type
      }
      return 'Item'
    },
    internalId() {
      if(this.integrationLinkData && this.integrationLinkData.options && this.integrationLinkData.options.unlink) {
        return this.integrationLinkData.options.unlink.internalId
      }
      return null
    },
    unlinkLink() {
      if(this.integrationLinkData && this.integrationLinkData.options && this.integrationLinkData.options.unlink) {
        return this.integrationLinkData.options.unlink.link
      }
      return null
    }
  },
  watch: {
  },
  methods: {
    show() {
      this.dialogForm = {}
      this.submitting = false

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var instance = this
      
      this.confirmMessage(`Unlink ${this.itemType}?`, '', { html: `Are you sure you want to unlink this ${this.itemType} from ${this.integrationName}?<br />This action cannot be undone and will cause the ${this.itemType} to be re-created in ${this.integrationName} on the next sync.` })
      .then(success => {
        if(success) {
          this.submitting = true

          this.$api.post(this.unlinkLink)
          .then(() => {
            instance.hide()
            this.successToast(`Successfully unlinked ${this.itemType} from ${this.integrationName}`)

            this.$emit('refresh')
          })
          .catch(err => {
            this.displayNetworkError(err, 'Error Unlinking Item')
          })
          .finally(() => {
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>